@if (shipment && shipment! | shouldShowContainers) {
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Containers ({{ shipment!.containers.length }})</mat-panel-title>
      </mat-expansion-panel-header>
      <table class="containers-table">
        @for (container of shipment!.containers; track container.containerNo) {
          <tr>
            <td class="display-flex">
              @if ((shipment! | shouldShowContainerDetails) && (hasAccessToContainers() | async) && !isArchived) {
                <a routerLink="/containers/{{ container.containerNo }}">{{ container.containerNo }}</a>
              } @else {
                <span>{{ container.containerNo }}</span>
              }
              @if (!isArchived && !!container.gpsTracking && windwardLinksLoading) {
                <div class="mat-spinner_loading">
                  <mat-spinner diameter="16"></mat-spinner>
                </div>
              }
              <span class="pl-2">{{ container.containerType }}</span>
            </td>
            @if (shipment! | shouldShowContainerDetails) {
              <td class="pl-2 pr-2">{{ container.status | uppercase }}</td>
              <td>{{ container.totalPackages }} {{ 'CLL ' }}</td>
              <td>{{ container.totalWeight || '-- ' }}{{ 'KG ' }}</td>
              <td>{{ (container.totalVolume | number: '1.0-3' : 'de-DE') || '-- ' }}{{ 'CBM ' }}</td>
            }
            @if (!isArchived) {
              @if (container.gpsTracking) {
                <a class="live-tracking" (click)="openLiveTracking(container.containerNo, container.gpsTracking)">{{
                  'LIVE TRACKING'
                }}</a>
              } @else if (!windwardLinksLoading) {
                @if (container.isVaildURL) {
                  <a class="live-tracking" (click)="openLiveTracking(container.containerNo)">{{ 'LIVE TRACKING' }}</a>
                }
              }
            }
          </tr>
        }
      </table>
    </mat-expansion-panel>
  </mat-accordion>
}
